import { render } from "./HealthCenterListComponent.vue?vue&type=template&id=511aa7f6"
import script from "./HealthCenterListComponent.vue?vue&type=script&lang=js"
export * from "./HealthCenterListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__